import { Modal } from "react-bootstrap";
import withPermission from "../../../core/common/autorisations/withPermission";
import {
  Action,
  buildPermission,
  Resource,
} from "../../../core/common/autorisations/permissionsMap";
import { useEffect, useState } from "react";
import { Spin } from "antd";
import { generateMonthlyTeacherReportPdf } from "../../../api/teachers";
import { toast } from "sonner";

//Typage des props parents
type Props = {
  show: boolean;
  metaData: any;
  onClose: () => void;
};
const MonthlyReportApercuModal = ({ show, metaData, onClose }: Props) => {
  const [pdfBlobUrl, setPdfBlobUrl] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const fetchMonthlyReportPDF = async () => {
    try {
      setIsLoading(true);
      setPdfBlobUrl("");

      const response = await generateMonthlyTeacherReportPdf(
        metaData?.id_teacherProfil,
        new Date(metaData?.month).getMonth() + 1,
        new Date(metaData?.month).getFullYear(),
        metaData?.academicYear?.id,
      );
      // console.log("response: ", response);
      const blob = new Blob([response], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);
      setPdfBlobUrl(url);
    } catch (error: any) {
      // console.log("erreur génération aperçu rapport mensuel: ", error);

      let errorMessage = "Une erreur s'est produite, réessayez plus tard";

      // Vérifie si on a bien un blob en réponse
      if (error.response && error.response.data instanceof Blob) {
        try {
          const text = await error.response.data.text(); // Convertir blob → texte
          const json = JSON.parse(text); // Parser texte → JSON
          errorMessage = json.error || json.message || errorMessage;
        } catch (parseErr) {
          // console.error("Impossible de parser l'erreur blob :", parseErr);
        }
      } else {
        errorMessage =
          error.response?.data?.message ||
          error.response?.data?.error ||
          error.message ||
          errorMessage;
      }

      toast.error(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (!show) setPdfBlobUrl("");
    if (
      show &&
      metaData?.id_teacherProfil &&
      metaData?.month &&
      metaData?.academicYear?.id
    )
      fetchMonthlyReportPDF();
  }, [show]);

  return (
    <>
      <Modal
        show={show}
        onHide={() => {
          onClose();
        }}
        size="xl"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Apercu du rapport mensuel: {metaData?.Teacher?.firstname}{" "}
            {metaData?.Teacher?.lastname} -{" "}
            {new Date(metaData?.month)
              .toLocaleString("fr-FR", { month: "long", year: "numeric" })
              .replace(/^\w/, (c) => c.toUpperCase())}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ height: "80vh" }}>
          <div className="w-100 h-100 d-flex justify-content-center align-items-center">
            {!pdfBlobUrl && isLoading ? (
              <Spin
                indicator={
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                }
              />
            ) : (
              <iframe
                src={pdfBlobUrl}
                style={{ width: "100%", height: "100%" }}
                title="Aperçu PDF"
              />
            )}
          </div>
        </Modal.Body>
        <Modal.Footer className="mt-2">
          <button className="btn btn-danger" onClick={() => onClose()}>
            Fermer
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default withPermission(
  MonthlyReportApercuModal,
  [buildPermission(Resource.TEACHER_REPORT, Action.READ)],
  "masquer",
);
